import { AxiosError, AxiosResponse } from "axios";
import { IExpensesData } from "../../interfaces/IExpenses";
import protheusProvider from "../providers/protheus.provider";

interface IRestPassword {
  token: string;
  password: string;
}

export class ForgetPasswordService {
  public async forgetService(user: string, sendBy: string): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.get('WSRESTGENDERCODE', {
        params: {
          user,
          sendBy
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async newPassword(objectParams: IRestPassword): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.put(`/WSRESETPASS`, objectParams);
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async codeValidate(user: string, code: string): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.get('WSRESTVALIDCODE', {
        params: {
          user,
          code
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }
}